import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const SUPPORTED_LANGS = ['en', 'pt', 'de'];

export default function Layout() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const match = location.pathname.match(/^\/(en|pt|de)(?:\/|$)/);
    if (match) {
      if (i18n.language !== match[1]) {
        i18n.changeLanguage(match[1]);
      }
    } else if (location.pathname === '/') {
      const detected = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : 'en';
      navigate(`/${detected}`, { replace: true });
    }
  }, [location.pathname, i18n, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-16">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}